
import { functions,auth, } from "@/scripts/firebase"
import {getDocs} from "firebase/firestore"
import { ModalConfirmProps, NoticeProps } from "@/scripts/datatypes"
import { ValidationObserver } from 'vee-validate'
import ModalConfirm from "@/components/ModalConfirm.vue"
import { Component,Mixins ,Watch} from "vue-property-decorator";
import Common from '@/mixins/common';
import { EnterSchoolArg, InvitationToken} from "@/common-datatypes";
import { httpsCallable } from "@firebase/functions";

@Component({
  components: {
    ModalConfirm
  }
})

export default class EnterSchool extends Mixins(Common) {
  isLoading = false
  tokenId = ''
  notice: NoticeProps = {}
  invitationSchools: (InvitationToken & {id: string})[] = []
  modalConfirmProps: ModalConfirmProps = {
    title: 'enterSchool.enterSchool',
    message: '',
    isLoading: false
  }
  showModal = false

  @Watch('tokenId')
  changeTokenId(val: string){
    if(val){
      const school = this.invitationSchools.find((school) => {return school.id === val})
      if(school && school.schoolName){
        this.modalConfirmProps.message = this.$t('enterSchool.confirm',{name: school.schoolName})
      }
    }
  }

  get schoolInviterName() {
    const token = this.invitationSchools.find((school) => {
      return school.id === this.tokenId
    })
    
    if(token && token.authorMeta && token.authorMeta.firstName && token.authorMeta.lastName){
      return this.$t('text.name',{lastName: token.authorMeta.lastName,firstName: token.authorMeta.firstName})
    }

    return ''
  }
  
  get observer() {
    return this.$refs.enterSchoolValidationObserver as InstanceType<typeof ValidationObserver>;
  }

  get isDisabled(){
    return this.invitationSchools.length === 0 || this.tokenId === ''
  }

  get uid(): string{
    return this.$store.getters.uid || ''
  }

  async created(){
    console.trace('created')
    try{
      this.isLoading = true
      const invitationTokens = await getDocs(this.$getInvitationTokenQuery(this.uid,'uid'))

      this.invitationSchools = invitationTokens.docs.map((doc) => {
        const data = doc.data() as InvitationToken
        return {...data,id: doc.id}
      })

      if(this.invitationSchools[0]){
        this.tokenId = this.invitationSchools[0].id
      }

    }catch(error){
      console.log(error)
    }finally{
      this.isLoading = false
    }
  }
 
  mounted(){
    console.trace('mounted');
 }

  destroyed() {
    console.trace('destroyed');
  }

  async enterSchool(confirm: boolean) {
    this.notice = {
      isShow: false
    }

    if(! confirm){
      this.showModal = false
      return
    }

    try{

      if(! await this.observer.validate()){
        this.showModal = false
        return
      }

      this.$store.commit("setLoading",true)
      this.modalConfirmProps.isLoading = true
      this.isLoading = true

      const enterSchool = httpsCallable(functions,'enterSchool')

      await enterSchool({
        token: this.tokenId
      } as EnterSchoolArg)

      this.showModal = false
      this.modalConfirmProps.isLoading = false

      this.notice = {
        message: this.$t('enterSchool.entered') as string,
        duration: 0,
        isShow: true,
        type: {'is-success': true}
      }
      
      this.observer.reset()

      await auth.currentUser?.getIdToken(true)

      await this.$router.push({name: 'schedule'}) //dashboard
      //TODO: go to dashboard finally.
    }catch(error){
      console.table(error)
      const errorCode = this.$getErrorCode(error)
      const errorMessage0 = this.$t('enterSchool.error') as string

      const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

      const errorField = this.$getErrorField(errorCode)

      if(errorMessage1 && errorField){
        this.observer.setErrors({
         [errorField]: errorMessage1
        })
      }

      const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
      this.notice = {
        message: errorMessage,
        isShow: true,
        type: {'is-danger': true}
			}
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.showModal = false
      this.modalConfirmProps.isLoading = false
    }
  }
}
